var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSection',{attrs:{"id":"scope-dashboard","title":_vm.$t(_vm.$getConst.pages.scopeSettingDashboard.scope) + ' ' + _vm.scope_name,"type":"page"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }